<template>
    <component :is="tag" v-if="renderContainer" v-show="animate || show" :class="['fold-container', {animate, open: show}]">
        <div v-if="animate" class="fold-container-content" :aria-hidden="!show">
            <slot v-bind="slotVariables"/>
        </div>
        <slot v-else v-bind="slotVariables"/>
    </component>
</template>

<script setup lang="ts">
    import {usePortuna} from '@/composables/portuna';
    import {useStore} from 'vuex';
    import {computed} from 'vue';

    const portuna = usePortuna();

    // @todo: not quite happy with the folding-solution -> consider to rather add listeners to children as it was handled before instead of using the store
    const props = withDefaults(
        defineProps<{
            tag?: string;
            group: string;
            defaultOpen?: boolean;
            renderClosed?: boolean;
            showOpen?: boolean;
            showClosed?: boolean;
            animate?: boolean;
        }>(),
        {
            tag: 'div',
            defaultOpen: false,
            renderClosed: true,
            showOpen: false,
            showClosed: false,
            animate: false,
        },
    );

    const store = useStore();

    const open = computed((): boolean =>
    {
        return !!store.state.foldContainer[props.group];
    });

    if (typeof store.state.foldContainer[props.group] === 'undefined' && props.defaultOpen)
    {
        store.dispatch(
            'setFold',
            {
                group: props.group,
                openState: true,
            },
        );
    }

    const toggle = () =>
    {
        store.dispatch('toggleFold', props.group);
    };

    const slotVariables = computed(() =>
    {
        return {
            open: open.value,
            toggle: toggle,
        };
    });

    const show = computed((): boolean =>
    {
        return (
            (props.showOpen && open.value) ||
            (props.showClosed && !open.value) ||
            (!props.showOpen && !props.showClosed)
        );
    });

    const renderContainer = computed((): boolean =>
    {
        return props.animate || props.renderClosed || show.value;
    });

    defineExpose(Object.assign({}, portuna, {
        componentName: 'FoldContainer',
    }));
</script>